import { render, staticRenderFns } from "./PassengerTripList.vue?vue&type=template&id=003ab6b6"
import script from "./PassengerTripList.vue?vue&type=script&lang=ts"
export * from "./PassengerTripList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports